// src/plugins/toaster.js
import { reactive } from 'vue'

const ALLOWED_PLACEMENTS = [
  'top-start','top-center','top-end',
  'middle-start','middle-center','middle-end',
  'bottom-start','bottom-center','bottom-end',
]

const state = reactive({
  items: [],
  seed: 0,
  defaultPlacement: 'top-center', // 👈 ค่าเริ่มต้นทั้งแอป
})

function buildClasses(color = 'danger', variant = 'solid') {
  if (variant === 'solid') return `bg-${color} text-white border-0 shadow-sm`
  return `bg-${color} bg-opacity-10 text-${color} border border-${color} border-opacity-25`
}

function normalizePlacement(p) {
  if (ALLOWED_PLACEMENTS.includes(p)) return p
  return state.defaultPlacement
}

function remove(id) {
  const i = state.items.findIndex(t => t.id === id)
  if (i > -1) state.items.splice(i, 1)
}

function push({
  text,
  color = 'danger',
  variant = 'solid',
  autohide = true,
  delay = 3000,
  title = '',
  icon = null,
  placement,              // 👈 รับ placement ต่อครั้ง
}) {
  const id = ++state.seed
  state.items.push({
    id,
    text,
    color,
    variant,
    classes: buildClasses(color, variant),
    autohide,
    delay,
    title,
    icon,
    placement: normalizePlacement(placement),
  })
  if (autohide) setTimeout(() => remove(id), delay + 200)
  return id
}

// ช็อตคัทตามชนิด พร้อม override placement/สี/ธีมได้
const success = (text, opts = {}) => push({ text, color: opts.color ?? 'success', variant: opts.variant ?? 'solid', ...opts })
const error   = (text, opts = {}) => push({ text, color: opts.color ?? 'danger',  variant: opts.variant ?? 'solid', ...opts })
const info    = (text, opts = {}) => push({ text, color: opts.color ?? 'info',    variant: opts.variant ?? 'soft',  ...opts })
const warning = (text, opts = {}) => push({ text, color: opts.color ?? 'warning', variant: opts.variant ?? 'soft',  ...opts })

// ตั้งค่าค่าเริ่มต้นทั่วแอป (เช่น default placement)
function config({ placement } = {}) {
  if (placement) state.defaultPlacement = normalizePlacement(placement)
}

export default {
  state,
  push,
  success,
  error,
  info,
  warning,
  remove,
  config,
  ALLOWED_PLACEMENTS, // เผื่ออยากอ้างอิงที่อื่น
}
